module.exports = __webpack_public_path__ + "img/LUB00358.d464208c.png";